import { initEventArchiveUI } from "./events/archive-ui";
import { initEventArchiveAjax } from "./events/archive-ajax";

export const initEvents = () => {
	// all custom event functions go through here
	initEventArchiveAjax();
	initEventArchiveUI();
};
